import { Link } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { isAdminRole, UserRole } from "../../app/userSlice";
import MiWriteLogo from "../../assets/MiWriteLogo";
import AccessibilityPopover from "../accessibility/AccessibilityPopover";
import NotificationPopover from "../notifications/NotificationPopover";
import SupportMenu from "../support/SupportMenu";
import CollapsibleNavbar from "./CollapsibleNavbar";
import ProfileMenu from "./ProfileMenu";
import UtahComposeLogo from "./UtahComposeLogo";

export default function Header() {
	const { config } = useAppSelector((state) => state.site);
	const {
		course,
		school,
		district,
		role,
		requiresAccountConfirmation,
		bypassTermsOfService,
		isImpersonating,
	} = useAppSelector((state) => state.user);

	const isAdmin = isAdminRole(role);

	function Navbar() {
		if ((!bypassTermsOfService || requiresAccountConfirmation) && !isImpersonating) return null;
		let showNav = true;
		if (isAdmin) {
			if (role == UserRole.DistrictAdmin) {
				if (!district) {
					showNav = false;
				}
			}
			if (role == UserRole.SchoolAdmin) {
				if (!school) {
					showNav = false;
				}
			}
		} else {
			showNav = !!course;
		}

		return <CollapsibleNavbar isCourseActive={course?.isActive} showLeftNav={showNav} />;
	}

	return (
		<header className="bg-primary-700 print:hidden">
			<div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
				<div className="relative flex items-center py-3 justify-between border-b border-white/20">
					<Link
						to={
							!bypassTermsOfService && !isImpersonating
								? "/termsOfService"
								: requiresAccountConfirmation && !isImpersonating
									? "/myAccount"
									: isAdmin
										? "/adminHome"
										: "/home"
						}>
						{config?.isUtahComposeSite ? (
							<UtahComposeLogo />
						) : (
							<MiWriteLogo className="h-12 text-white" />
						)}
					</Link>
					{(bypassTermsOfService || isImpersonating) && (
						<div className="flex justify-center space-x-6">
							<AccessibilityPopover />
							{!isAdmin && <NotificationPopover />}
							<SupportMenu />
							<ProfileMenu />
						</div>
					)}
				</div>
				<div className="border-b border-white/20">
					<Navbar />
				</div>
			</div>
		</header>
	);
}
